import { jsx as e } from "react/jsx-runtime";
import { BaseTypography as o } from "../../common/components/BaseStyledComponents/BaseTypography.js";
import { useTheme as t, Skeleton as n } from "@mui/joy";
const r = ({ children: r2, loading: l, level: i = "body-sm", fontWeight: m = "600" }) => {
  const a = t();
  return e(o, { level: i, lightColor: a.palette.neutral[800], fontWeight: m, component: "div", children: e(n, { variant: "text", loading: l, level: i, sx: { width: "200px", borderRadius: "8px" }, children: l ? null : r2 }) });
};
export {
  r as Value,
  r as default
};
//# sourceMappingURL=Value.js.map
